import styled from "styled-components";

export const HistoryContainer = styled.div``;

export const Header = styled.div`
  padding: 12px 28px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 10px;
  background: var(--filter-bar-bg);
  .filter-icon {
    p {
      color: #fff;
    }
    svg {
      path {
        fill: #fff;
      }
    }
  }
  
  .label-wrapper {
    .label {
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      color: var(--theme-text);
    }
  }
  .refresh-btn {
    background-color: var(--input-background);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    width: 30px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
    border-left: 1px solid #cdcfd0;
    svg {
      cursor: pointer;
    }
    :first-child {
      border: none;
    }
  }
  @media (max-width: 850px) {
    &.display {
      display: none;
    }
    background: transparent;
    padding: 0;
    > div {
      border: none;
    }
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding-left: 10px;
    min-height: 30px;
    width: 100px;
  }
  img {
    position: absolute;
    right: 8px;
  }
`;

export const Container = styled.div`
  background-color: #fafcff;
  padding: 0 28px 22px;
  max-height: calc(100vh - 120px);
  overflow: auto;
  @media (max-width: 1547px) {
    max-height: calc(100vh - 148px);
  }
`;

export const HistoryTableInnerSection = styled.div`
  width: 100%;
  height: calc(100vh - 128px);
  overflow: auto;
  &.no-pagination{
    .MuiDataGrid-footerContainer {
      display: none !important;
    }
  }
  .word-wrap{
    white-space: normal !important;
    word-break: break-word !important;
  }
  .inner-div {
   p {
    display: flex;
    align-items: center;
    gap: 5px;
   }
  }
  .super-time-theme--cell {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--text-primary);
    opacity: 0.5;
    font-weight: 500;
  }
  .action-btn {
    .round-btn {
      border-color: var(--border-color);
      color: var(--text-primary);
    }
  }
  .table-btn-wrapper {
    padding: 0;
  }
  .text-cell-inner-data {
    .show-more-btn {
      display: none;
    }
  }
  .MuiDataGrid-virtualScrollerRenderZone {
      > .MuiDataGrid-row {
        > div {
          
          .cars-cell {
          span {
            display: inline-flex;
            align-items: center;
          }            
          }
        }
      }
    }
    .inner-dot-add {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      p {
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  @media (max-width: 1195px) {
    max-height: calc(100vh - 170px);
  }
  @media (max-width: 850px) {
    max-height: calc(100vh - 185px);

    .for-show-more {
    }
    .display,
    .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.received-column.display {
      display: none;
    }
    .MuiDataGrid-cell {
      align-items: flex-start !important;
      padding: 6px !important;
    }
    .MuiDataGrid-virtualScrollerRenderZone {
      > .MuiDataGrid-row {
        > div {
          :nth-child(1) {
            display: none;
          }
          .cars-cell {
            flex-direction: column;
          }
        }
      }
    }
    .MuiDataGrid-columnHeadersInner {
      > div {
        > div {
          :last-child {
            min-width: 70px !important;
            max-width: 70px !important;
          }
          :nth-last-child(2) {
            min-width: 55px !important;
            max-width: 55px !important;
          }
          :nth-last-child(3) {
            min-width: 62px !important;
            max-width: 62px !important;
            padding: 0;
          }
        }
      }
    }
    .MuiDataGrid-row {
      max-height: fit-content !important;

      > div {
        max-height: fit-content !important;
        :nth-child(3) {
          max-width: 100% !important;
          flex: 1 !important;
          width: 100% !important;
          overflow: unset !important;
          white-space: normal !important;
        }
        :last-child {
          min-width: 70px !important;
          max-width: 70px !important;
          > div {
            display: flex !important;
            justify-content: center;
            width: 100%;
          }
        }

        :nth-last-child(2) {
          min-width: 55px !important;
          max-width: 55px !important;
        }

        :nth-last-child(3) {
          min-width: 62px !important;
          max-width: 62px !important;
        }
      }
    }
    .dot-add {
    }
    .inner-dot-add {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .show-more-btn {
      border: none;
      background-color: transparent;
      font-weight: 600;
      font-size: 12px;
      line-height: 150.5%;
      color: #00a692;
      text-decoration-line: underline;
      padding: 0;
    }
    .text-cell-inner-data {
      overflow: hidden;
      .show-more-btn {
        display: flex;
      }
      &.dot-add {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;
